import { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { adminlimit, downloadUrl } from "../Settings/Config";
import api from "../../utils/axios";
import $ from "jquery";
import { showContaimerLoader, encodeValue, showPageCount, showDBDate, showDate, showHTMLText, showDateTime, calculateStatus_, customStyles, showLoader, hideLoader } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
import { format } from "date-fns";
import reportfield from "./report.json";
const module = "reports";
const modulePath = "/reports";
const moduleName = "Reports";
const reportList = [
  { label: "New Profile", value: "newProfile" },
  { label: "Calls Made", value: "callsMade" },
  { label: "Proposals", value: "proposals" },
  { label: "Sign On", value: "signOn" },
  { label: "Sign Off", value: "signOff" },
  { label: "Due for Signoff", value: "dueForSignoff" },
  { label: "Available Candidates", value: "availableCandidates" },
  { label: "On Board", value: "onBoard" },
  /* { label: "Vessel Assignment", value: "vesselAssignment" }, */
  { label: "Reminder", value: "reminder" },
  { label: "Crew List Month Wise", value: "crewListMonthWise" },
  { label: "IMO Crew List Month Wise", value: "imocrewListMonthWise" },
  { label: "Relief Plan", value: "reliefPlan" },
  { label: "Due for Renewal", value: "dueForRenewal" },
  { label: "COC/CDC Document", value: "cocDocument" },
  /* { label: "Worked With us", value: "dueForWorkedWith" }, */
];
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLimit: { label: adminlimit, value: adminlimit },
      pageLimitmedical: { label: adminlimit, value: adminlimit },
      candidateStatus: { label: "Active", value: 1 },
      loading: false,
      startReport: false,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],

      medicalloading: false,
      medicaltotalRecords: 0,
      medicaltotalPage: 0,
      medicalcurrentPage: 1,
      medicallistdata: [],

      name: "",
      status: "",
      reportType: "",
      fromDate: "",
      toDate: "",
      rankList: [],
      companyList: [],
      vesselList: [],
      userList: [],
      userIDList: [],
      newProfilefromDate: "",
      newProfiletoDate: "",
      proposalsfilterstatus: { label: "Proposed", value: "Proposed" },
      viewDocumentFile:"",
      viewDocumentTitle:""
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    /* this.loadList(1); */
    this.loadDropDownList();
  }

  loadDropDownList() {
    api
      .get("rank/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ rankList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("company/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ companyList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("user/dropdownuser")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ userList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("user/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ userIDList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });

    this.loadVessel();
  }
  loadVessel() {
    const reportType_ = this.state.reportType?.value || "";
    const company = this.state[`${reportType_}company`]?.value || "";
    let where = "";
    if (company !== "") {
      where = `?companyID=${company}`;
    }
    api
      .get(`vessel/alldropdown${where}`)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ vesselList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  searchList(exportExcel, e) {
    e.preventDefault();
    const reportType_ = this.state.reportType?.value || "";
    this.setState({ loading: !exportExcel ? true : false, [`${reportType_}currentPage`]: !exportExcel ? 1 : this.state[`${reportType_}currentPage`] }, () => {
      this.loadList(!exportExcel ? 1 : this.state[`${reportType_}currentPage`], "", exportExcel);
    });
  }

  loadList(offset, apiType = "", exportExcel = false) {
    this.setState({ startReport: true });

    const reportType_ = this.state.reportType?.value || "";
    const startDate = this.state[`${reportType_}fromDate`];
    const searchkeyword = this.state[`${reportType_}searchkeyword`] || "";

    const endDate = this.state[`${reportType_}toDate`];
    const user = this.state[`${reportType_}user`]?.value || "";
    const company = this.state[`${reportType_}company`]?.value || "";
    const vessel = this.state[`${reportType_}vessel`]?.value || "";
    const rank = this.state[`${reportType_}rank`]?.value || "";
    const filterstatus = this.state[`${reportType_}filterstatus`]?.value || "Proposed";
    const candidateStatus = this.state.candidateStatus?.value ?? 1;

    const postObject = {
      limit: this.state[`${reportType_}pageLimit`]?.value ?? 10,
      startDate: startDate !== "" ? showDBDate(startDate) : "",
      endDate: endDate !== "" ? showDBDate(endDate) : "",
      filteruser: user,
      companyName: company,
      vesselName: vessel,
      filterrank: rank,
      status: filterstatus,
      candidateStatus,
      searchkeyword,
      offset: offset,
      exportExcel,
      reportType: reportType_,
    };
    if (apiType === "") {
      if (exportExcel) {
        showLoader("exportData");
      } else {
        this.setState({ loading: true });
      }

      const apipath = reportfield[reportType_].apipath;
      api
        .post(`${module}/${apipath}`, postObject, exportExcel ? { responseType: "blob" } : {})
        .then((res) => {
          if (exportExcel) {
            // download file
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            const downloadFileName = `${reportfield[this.state.reportType?.value].fileName}-${format(new Date(), "dd-LLL-yyyy-hh:mm a")}.xlsx`;
            link.setAttribute("download", downloadFileName);
            document.body.appendChild(link);
            link.click();
            link.remove();

            this.setState({ loading: false });
            hideLoader("exportData");
            return;
          }

          // normal json list response
          if (res.data.status === "ok") {
            this.setState({
              [`${reportType_}listdata`]: res.data.result,
              loading: false,
              [`${reportType_}totalRecords`]: res.data.totalRecords,
              [`${reportType_}totalPage`]: res.data.totalPages,
            });
          }
        })
        .catch((err) => {
          console.error(err);
          hideLoader("exportData");
          this.setState({
            [`${reportType_}listdata`]: [],
            loading: false,
            [`${reportType_}totalRecords`]: 0,
            [`${reportType_}totalPage`]: 0,
          });
        });
    }
    if (reportType_ === "dueForRenewal") {
      const postObject_ = {
        limit: this.state.pageLimitmedical?.value || 10,
        startDate: startDate !== "" ? showDBDate(startDate) : "",
        endDate: endDate !== "" ? showDBDate(endDate) : "",
        filteruser: user,
        companyName: company,
        vesselName: vessel,
        filterrank: rank,
        status: filterstatus,
        offset: offset,
      };
      this.setState({ medicalloading: true });
      api
        .post(`${module}/renewalmedical`, postObject_)
        .then((res) => {
          if (res.data.status === "ok") {
            this.setState({ medicallistdata: res.data.result, medicalloading: false, medicaltotalRecords: res.data.totalRecords, medicaltotalPage: res.data.totalPages });
          }
        })
        .catch((err) => {
          console.error(err);
          this.setState({ medicallistdata: [], medicalloading: false, medicaltotalRecords: 0, medicaltotalPage: 0 });
        });
    }
  }
  edit(editID, e) {
    e.preventDefault();
    this.props.history.push({
      pathname: `${modulePath}/edit`,
      state: { editID: encodeValue(editID) },
    });
  }
  sateValChange = (field, value, addParam) => {
    const reportType = this.state.reportType?.value || "";
    if (field === "pageLimitmedical") {
      this.setState({ pageLimitmedical: value, medicalcurrentPage: 1 }, () => {
        this.loadList(1, "medical");
      });
    } else if (addParam === "medical") {
      if (field === "page") {
        this.setState(
          {
            medicalloading: true,
            medicalcurrentPage: value,
          },
          () => {
            this.loadList(value, "medical");
          },
        );
      } else if (field === "pageLimit") {
        this.setState({ medicalpageLimit: value, medicalcurrentPage: 1 }, () => {
          this.loadList(1, "medical");
        });
      }
    } else {
      if (field === "page") {
        this.setState(
          {
            loading: true,
            [`${reportType}currentPage`]: value,
          },
          () => {
            this.loadList(value);
          },
        );
      } else if (field === "pageLimit") {
        this.setState({ [`${reportType}pageLimit`]: value, [`${reportType}currentPage`]: 1 }, () => {
          this.loadList(1);
        });
      }
    }
  };
  handleChangeText(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value }, () => {
      if (name.indexOf("company") >= 0) {
        this.setState({ [`${this.state.reportType?.value}vessel`]: "" }, () => {
          this.loadVessel();
        });
      } else if (name === "reportType") {
        const reportType = this.state.reportType?.value || "";
        const finallistdata__ = this.state[`${reportType}listdata`] ?? [];
        if (finallistdata__.length === 0) {
          this.setState({ startReport: false });
        } else {
          this.setState({ startReport: true });
        }
      }
    });
  }
  viewFile(viewDocumentFile, viewDocumentTitle, e) {
    e.preventDefault();
    this.setState({ viewDocumentFile, viewDocumentTitle }, () => {
      $("#viewDoc").trigger("click");
    });
  }
  closePopup() {
    this.setState({ viewDocumentFile: "", viewDocumentTitle: "" });
  }

  render() {
    const reportType = this.state.reportType?.value || "";
    let finallistdata = this.state[`${reportType}listdata`] ?? [];
    const pageLimitCu = this.state[`${reportType}pageLimit`]?.value ?? 10;
    const pageLimitCuSelect = this.state[`${reportType}pageLimit`] || { label: adminlimit, value: adminlimit };
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />
      <button
                    className="btn btn-sm btn-success badge mx-4 hidden"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#extralargemodalViewDoc"
                    data-backdrop="static"
                    data-keyboard="false"
                    id="viewDoc"
                  >
                    <i className="fa fa-plus"></i> Add New
                  </button>
            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid mx-3">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                  </div>
                  <div className="row">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="form-row">
                            <div className="col-md-4">
                              <Select
                                value={this.state.reportType}
                                onChange={this.handleSelectChange.bind(this, "reportType")}
                                placeholder="Select Report"
                                isClearable={true}
                                options={reportList}
                                styles={customStyles}
                              />
                            </div>
                          </div>
                          {reportType !== "" && (
                            <div className="form-row">
                              <div className="form-group col-md-3">
                                <label className="form-label">Search Keywords</label>
                                <input type="text" className="form-control" placeholder="Search Keywords..." name={`${reportType}searchkeyword`} onChange={this.handleChangeText.bind(this)} />
                              </div>
                              {["cocDocument"].indexOf(reportType) < 0 && (
                                <div className="form-group col-md-3">
                                  <label className="form-label">From Date</label>
                                  <DatePicker
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    placeholderText="Select From Date"
                                    className="form-control"
                                    onKeyDown={(e) => e.preventDefault()}
                                    selected={this.state[`${reportType}fromDate`]}
                                    dateFormat="dd-MM-yyyy"
                                    onChange={this.handleSelectChange.bind(this, `${reportType}fromDate`)}
                                  />
                                </div>
                              )}
                              {["onBoard", "reliefPlan", "cocDocument"].indexOf(reportType) < 0 && (
                                <div className="form-group col-md-3">
                                  <label className="form-label">To Date</label>
                                  <DatePicker
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    placeholderText="Select To Date"
                                    className="form-control"
                                    onKeyDown={(e) => e.preventDefault()}
                                    selected={this.state[`${reportType}toDate`]}
                                    dateFormat="dd-MM-yyyy"
                                    minDate={this.state[`${reportType}fromDate`] ? this.state[`${reportType}fromDate`] : ""}
                                    onChange={this.handleSelectChange.bind(this, `${reportType}toDate`)}
                                  />
                                </div>
                              )}

                              {["proposals"].indexOf(reportType) >= 0 && (
                                <div className="col-md-3">
                                  <label className="form-label">Status</label>
                                  <Select
                                    value={this.state[`${reportType}filterstatus`]}
                                    onChange={this.handleSelectChange.bind(this, `${reportType}filterstatus`)}
                                    placeholder="Select Status"
                                    options={[
                                      { label: "Proposed", value: "Proposed" },
                                      { label: "Joined", value: "Joined" },
                                      { label: "Approved", value: "Approved" },
                                      { label: "Rejected", value: "Rejected" },
                                    ]}
                                    styles={customStyles}
                                  />
                                </div>
                              )}
                              {["callsMade"].indexOf(reportType) >= 0 && (
                                <div className="col-md-3">
                                  <label className="form-label">User</label>
                                  <Select
                                    value={this.state[`${reportType}user`]}
                                    onChange={this.handleSelectChange.bind(this, `${reportType}user`)}
                                    placeholder="Select User"
                                    isClearable={true}
                                    options={this.state.userIDList}
                                    styles={customStyles}
                                  />
                                </div>
                              )}

                              {["newProfile"].indexOf(reportType) >= 0 && (
                                <div className="col-md-3">
                                  <label className="form-label">User</label>
                                  <Select
                                    value={this.state[`${reportType}user`]}
                                    onChange={this.handleSelectChange.bind(this, `${reportType}user`)}
                                    placeholder="Select User"
                                    isClearable={true}
                                    options={this.state.userList}
                                    styles={customStyles}
                                  />
                                </div>
                              )}
                              {["proposals", "signOn", "signOff", "dueForSignoff", "onBoard", "crewListMonthWise", "imocrewListMonthWise"].indexOf(reportType) >= 0 && (
                                <div className="col-md-3">
                                  <label className="form-label">Company</label>
                                  <Select
                                    value={this.state[`${reportType}company`]}
                                    onChange={this.handleSelectChange.bind(this, `${reportType}company`)}
                                    placeholder="Select Company"
                                    isClearable={true}
                                    options={this.state.companyList}
                                    styles={customStyles}
                                  />
                                </div>
                              )}
                              {["signOn", "signOff", "dueForSignoff", "onBoard", "crewListMonthWise", "imocrewListMonthWise"].indexOf(reportType) >= 0 && (
                                <div className="col-md-3">
                                  <label className="form-label">Vessel Name</label>
                                  <Select
                                    value={this.state[`${reportType}vessel`]}
                                    onChange={this.handleSelectChange.bind(this, `${reportType}vessel`)}
                                    placeholder="Select Vessel Name"
                                    isClearable={true}
                                    options={this.state.vesselList}
                                    styles={customStyles}
                                  />
                                </div>
                              )}
                              {["availableCandidates"].indexOf(reportType) >= 0 && (
                                <div className="col-md-3">
                                  <label className="form-label">Rank</label>
                                  <Select
                                    value={this.state[`${reportType}rank`]}
                                    onChange={this.handleSelectChange.bind(this, `${reportType}rank`)}
                                    placeholder="Select Rank"
                                    isClearable={true}
                                    options={this.state.rankList}
                                    styles={customStyles}
                                  />
                                </div>
                              )}
                              {["cocDocument"].indexOf(reportType) < 0 && (
                                <div className="col-md-2">
                                  <label className="form-label">Candidate Status</label>
                                  <Select
                                    value={this.state.candidateStatus}
                                    onChange={this.handleSelectChange.bind(this, `candidateStatus`)}
                                    placeholder="Select Status"
                                    options={[
                                      { label: "Active", value: 1 },
                                      { label: "Inactive", value: 0 },
                                    ]}
                                  />
                                </div>
                              )}

                              <div className="col-md-3">
                                <a href="/" className="btn btn-primary mt-6" onClick={this.searchList.bind(this, false)}>
                                  Search
                                </a>
                                {finallistdata.length > 0 && (
                                  <a href="/" className="btn btn-secondary mt-6  offset-1" id="exportData" onClick={this.searchList.bind(this, true)}>
                                    Export
                                  </a>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {this.state.startReport && (
                    <div className="row">
                      <div className="col-xl-12">
                        <div className="card">
                          <div>
                            <div className="card-header">
                              {Number(this.state[`${reportType}totalPage`] ?? 0) > 0 &&
                                showPageCount(
                                  moduleName,
                                  Number(this.state[`${reportType}currentPage`] ?? 0),
                                  Number(this.state[`${reportType}totalPage`] ?? 0),
                                  Number(this.state[`${reportType}totalRecords`] ?? 0),
                                  this.sateValChange,
                                  pageLimitCuSelect,
                                )}
                            </div>
                            <div className="card-body">
                              <div className="table-responsive">
                                <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                  <thead className="table-primary">
                                    <tr>
                                      {reportfield[reportType].fieldName.map((fitem, findex) => {
                                        return <th key={findex}>{fitem.label}</th>;
                                      })}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.loading ? (
                                      <tr>
                                        <td colSpan={reportfield[reportType].fieldName.length}>{showContaimerLoader()}</td>
                                      </tr>
                                    ) : finallistdata.length > 0 ? (
                                      finallistdata.map((item, index) => {
                                        return (
                                          <tr key={index} className={`${item.branchStatus === "I" ? "bg-danger text-white" : ""}`}>
                                            {reportfield[reportType].fieldName.map((fitem, findex) => {
                                              if (fitem.name === "candidateId") {
                                                return (
                                                  <td key={findex}>
                                                    <a href={`/candidate/view/${item[fitem.name]}`} target="_blank" rel="noreferrer">
                                                      {item[fitem.name]}
                                                    </a>
                                                  </td>
                                                );
                                              } else if (fitem.datatype === "file") {
                                                let filePath = '';
                                                let fileName = '';
                                                if(fitem.name==='passbook') {
                                                  filePath = item[fitem.name] !== "" && item[fitem.name] !== null ? `${downloadUrl}views/public/bank_details/${item[fitem.name]}` : ""
                                                  fileName = "Passbook";
                                                }else if(fitem.name==='pan_card') {
                                                  filePath = item[fitem.name] !== "" && item[fitem.name] !== null ? `${downloadUrl}views/public/bank_details/pan_card/${item[fitem.name]}` : ""
                                                  fileName = "PAN Card";
                                                }else if(fitem.name==='document_files') {
                                                  filePath = item[fitem.name] !== "" && item[fitem.name] !== null ? `${downloadUrl}views/public/files/${item[fitem.name]}` : ""
                                                  fileName = "Document";
                                                }
                                               
                                                return (
                                                  <td className="text-center" key={findex}>
                                                    {item[fitem.name] !== "" && item[fitem.name] !== null && (
                                                      <a href="/" onClick={this.viewFile.bind(this, filePath, `View ${fileName}`)}>
                                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                                      </a>
                                                    )}
                                                  </td>
                                                );
                                              } else if (fitem.name === "eocDate") {
                                                const contractExtensionDate = item.contractExtensionDate || "";
                                                return (
                                                  <td key={findex}>
                                                    {contractExtensionDate !== "" && contractExtensionDate !== null && contractExtensionDate !== "1970-01-01"
                                                      ? showDate(contractExtensionDate)
                                                      : showDate(item.eoc)}
                                                  </td>
                                                );
                                              } else if (fitem.name === "eoc_status") {
                                                const contractExtensionDate = item.contractExtensionDate || "";
                                                const statusColor =
                                                  contractExtensionDate !== "" && contractExtensionDate !== null && contractExtensionDate !== "1970-01-01"
                                                    ? calculateStatus_(contractExtensionDate)
                                                    : calculateStatus_(item.eoc);

                                                return (
                                                  <td className="text-center" key={findex}>
                                                    <span className={`badge bg-${statusColor?.color} badge-sm  me-2 mb-2 mt-2`}>{statusColor?.status || ""}</span>
                                                  </td>
                                                );
                                              } else if (fitem.datatype === "r_date_status") {
                                                const r_date = item[fitem.name] || "";
                                                const statusColor = calculateStatus_(r_date);
                                                return (
                                                  <td className="text-center" key={findex}>
                                                    <span className={`badge bg-${statusColor?.color} badge-sm  me-2 mb-2 mt-2`}>{statusColor?.status || ""}</span>
                                                  </td>
                                                );
                                              } else {
                                                let displayVal = "";
                                                if (fitem.name === "sno") {
                                                  displayVal = (this.state[`${reportType}currentPage`] - 1) * parseInt(pageLimitCu) + parseInt(index) + 1;
                                                } else if (fitem?.datatype === "date") {
                                                  displayVal = showDate(item[fitem.name]);
                                                } else if (fitem?.datatype === "datetime") {
                                                  displayVal = showDateTime(item[fitem.name]);
                                                } else if (fitem?.datatype === "html") {
                                                  displayVal = showHTMLText(item[fitem.name] || "");
                                                } else {
                                                  displayVal = item[fitem.name];
                                                }
                                                return <td key={findex}>{displayVal}</td>;
                                              }
                                            })}
                                          </tr>
                                        );
                                      })
                                    ) : (
                                      <tr>
                                        <td className="text-center" colSpan={reportfield[this.state.reportType?.value].fieldName.length}>
                                          No {moduleName} Found
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                              {Number(this.state[`${reportType}totalPage`] ?? 0) > 0 && (
                                <Pagenation
                                  params={{
                                    totalRecords: Number(this.state[`${reportType}totalRecords`] ?? 0),
                                    totalPage: Number(this.state[`${reportType}totalPage`] ?? 0),
                                    currentPage: Number(this.state[`${reportType}currentPage`] ?? 0),
                                  }}
                                  sateValChange={this.sateValChange}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        {reportType === "dueForRenewal" && (
                          <div className="card">
                            <div>
                              <div className="card-header">
                                {parseInt(this.state.medicaltotalPage) > 0 &&
                                  showPageCount(
                                    moduleName,
                                    this.state.medicalcurrentPage,
                                    this.state.medicaltotalPage,
                                    this.state.medicaltotalRecords,
                                    this.sateValChange,
                                    this.state.pageLimitmedical,
                                    "medical",
                                  )}
                              </div>
                              <div className="card-body">
                                <div className="table-responsive">
                                  <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                    <thead className="table-primary">
                                      <tr>
                                        {reportfield.dueForRenewalMedical.fieldName.map((fitem, findex) => {
                                          return <th key={findex}>{fitem.label}</th>;
                                        })}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.medicalloading ? (
                                        <tr>
                                          <td colSpan={reportfield.dueForRenewalMedical.fieldName.length}>{showContaimerLoader()}</td>
                                        </tr>
                                      ) : this.state.medicallistdata.length > 0 ? (
                                        this.state.medicallistdata.map((item, index) => {
                                          return (
                                            <tr key={index}>
                                              {reportfield.dueForRenewalMedical.fieldName.map((fitem, findex) => {
                                                if (fitem.name === "candidateId") {
                                                  return (
                                                    <td key={findex}>
                                                      <a href={`/candidate/view/${item[fitem.name]}`} target="_blank" rel="noreferrer">
                                                        {item[fitem.name]}
                                                      </a>
                                                    </td>
                                                  );
                                                } else if (fitem.datatype === "file") {
                                                  let filePath = '';
                                                  let fileName = '';
                                                  if(fitem.name==='passbook') {
                                                    filePath = item[fitem.name] !== "" && item[fitem.name] !== null ? `${downloadUrl}views/public/bank_details/${item[fitem.name]}` : ""
                                                  }else if(fitem.name==='pan_card') {
                                                    filePath = item[fitem.name] !== "" && item[fitem.name] !== null ? `${downloadUrl}views/public/bank_details/pan_card/${item[fitem.name]}` : ""
                                                  }else if(fitem.name==='upload') {
                                                    filePath = item[fitem.name] !== "" && item[fitem.name] !== null ? `${downloadUrl}views/public/uploads/medical/${item[fitem.name]}` : ""
                                                    fileName = "Medical";
                                                  }
                                                  
                                                
                                                  return (
                                                    <td className="text-center" key={findex}>
                                                      {item[fitem.name] !== "" && item[fitem.name] !== null && (
                                                        <a href="/" onClick={this.viewFile.bind(this, filePath, `View ${fileName}`)}>
                                                          <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                                        </a>
                                                      )}
                                                    </td>
                                                  );
                                                } else if (fitem.name === "eocDate") {
                                                  const contractExtensionDate = item.contractExtensionDate || "";
                                                  return (
                                                    <td key={findex}>
                                                      {contractExtensionDate !== "" && contractExtensionDate !== null && contractExtensionDate !== "1970-01-01"
                                                        ? showDate(contractExtensionDate)
                                                        : showDate(item.eoc)}
                                                    </td>
                                                  );
                                                } else if (fitem.name === "eoc_status") {
                                                  const contractExtensionDate = item.contractExtensionDate || "";
                                                  const statusColor =
                                                    contractExtensionDate !== "" && contractExtensionDate !== null && contractExtensionDate !== "1970-01-01"
                                                      ? calculateStatus_(contractExtensionDate)
                                                      : calculateStatus_(item.eoc);

                                                  return (
                                                    <td className="text-center" key={findex}>
                                                      <span className={`badge bg-${statusColor?.color} badge-sm  me-2 mb-2 mt-2`}>{statusColor?.status || ""}</span>
                                                    </td>
                                                  );
                                                } else if (fitem.datatype === "r_date_status") {
                                                  const r_date = item[fitem.name] || "";
                                                  const statusColor = calculateStatus_(r_date);
                                                  return (
                                                    <td className="text-center" key={findex}>
                                                      <span className={`badge bg-${statusColor?.color} badge-sm  me-2 mb-2 mt-2`}>{statusColor?.status || ""}</span>
                                                    </td>
                                                  );
                                                } else {
                                                  let displayVal = "";
                                                  if (fitem.name === "sno") {
                                                    displayVal = (this.state.medicalcurrentPage - 1) * parseInt(this.state.pageLimitmedical?.value || 10) + parseInt(index) + 1;
                                                  } else if (fitem?.datatype === "date") {
                                                    displayVal = showDate(item[fitem.name]);
                                                  } else if (fitem?.datatype === "datetime") {
                                                    displayVal = showDateTime(item[fitem.name]);
                                                  } else if (fitem?.datatype === "html") {
                                                    displayVal = showHTMLText(item[fitem.name] || "");
                                                  } else {
                                                    displayVal = item[fitem.name];
                                                  }
                                                  return <td key={findex}>{displayVal}</td>;
                                                }
                                              })}
                                            </tr>
                                          );
                                        })
                                      ) : (
                                        <tr>
                                          <td className="text-center" colSpan={reportfield.dueForRenewalMedical.fieldName.length}>
                                            No Medical Found
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                                {parseInt(this.state.medicaltotalPage) > 1 && (
                                  <Pagenation
                                    params={{
                                      totalRecords: this.state.medicaltotalRecords,
                                      totalPage: this.state.medicaltotalPage,
                                      currentPage: this.state.medicalcurrentPage,
                                      addParam:"medical"
                                    }}
                                    
                                    sateValChange={this.sateValChange}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
                  <div className="modal fade" id="extralargemodalViewDoc" tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
                            <div className="modal-dialog modal-xl" role="document">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title">{this.state.viewDocumentFile !== "" ? `View ${this.state.viewDocumentTitle}` : "Add New Document"}</h5>
                                  <button className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                                    <span aria-hidden="true">×</span>
                                  </button>
                                </div>
                                {this.state.viewDocumentFile !== "" && (
                                  <div>
                                    <iframe src={`${this.state.viewDocumentFile}`} width="100%" height="500px" title="View File"></iframe>
                                    <div className="modal-footer">
                                      <button className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                                        Close
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
        <Footer />
      </div>
    );
  }
}

export default List;
